const Unauthorized = () => {
  return (
    <h2 className="text-center my-5">
      401 <small className="d-block text-body-secondary">Unauthorized</small>
    </h2>
  );
};

export default Unauthorized;
